import KitModaImport from "./kitModa/KitModaImport";
import RossignolV2Import from "./tracciatiFornitori/RossignolV2Import";
import { /* React, */ useState } from "react";
import stilePulsanti from "../interfaccia/stilePulsanti";
import TracciatoFornitore from "./tracciatiFornitori/TracciatoFornitore";

function AreaCSVupload({ utente }) {
  const [tab, setTab] = useState("tracciatoweb");
  /* const utente = props.utente; */

  const { vociMenuTabs, vociMenuTabsSelezionata } = stilePulsanti;

  function cambiaTab(e) {
    e.preventDefault();
    setTab(e.target.id);
  }

  return (
    <div className="sfondoBiancoTema flex">
      <div className="w-10 pt2 pb2 pl4 br bordoColAlt">
        <h3>Tracciati fornitori</h3>
        <p
          id="tracciatoweb"
          onClick={cambiaTab}
          className={
            tab === "tracciatoweb" ? vociMenuTabsSelezionata : vociMenuTabs
          }
        >
          Tracciato universale
        </p>
        <p
          id="rossignol-v2"
          onClick={cambiaTab}
          className={tab === "rossignol-v2" ? vociMenuTabsSelezionata : vociMenuTabs}
        >
          Rossignol group v2
        </p>
        <p
          id="Oberalp"
          onClick={cambiaTab}
          className={tab === "Oberalp" ? vociMenuTabsSelezionata : vociMenuTabs}
        >
          Oberalp group
        </p>
        <p
          id="garmont"
          onClick={cambiaTab}
          className={tab === "garmont" ? vociMenuTabsSelezionata : vociMenuTabs}
        >
          Garmont
        </p>
        <p
          id="reusch"
          onClick={cambiaTab}
          className={tab === "reusch" ? vociMenuTabsSelezionata : vociMenuTabs}
        >
          Reusch
        </p>
        <p
          id="poc"
          onClick={cambiaTab}
          className={tab === "poc" ? vociMenuTabsSelezionata : vociMenuTabs}
        >
          Poc
        </p>
        <p
          id="Rh"
          onClick={cambiaTab}
          className={tab === "Rh" ? vociMenuTabsSelezionata : vociMenuTabs}
        >
          Rh+
        </p>
        <p
          id="Leki"
          onClick={cambiaTab}
          className={tab === "Leki" ? vociMenuTabsSelezionata : vociMenuTabs}
        >
          Leki
        </p>
        <h3>Kit</h3>
        <p id="kit-moda" onClick={cambiaTab}
          className={tab === "kit-moda" ? vociMenuTabsSelezionata : vociMenuTabs}>
          Kit Moda
        </p>
      </div>
      <div className="pa2 w-90">
        {tab === "kit-moda" && <KitModaImport utente={utente} />}
        {tab === "tracciatoweb" && (
          <TracciatoFornitore utente={utente}
            nomeFornitore="tracciatoweb"
            titoloPagina="Tracciato web universale"
          />
        )}
        {tab === "rossignol-v2" && <RossignolV2Import utente={utente} />}
        {tab === "garmont" && (
          <TracciatoFornitore utente={utente}
            nomeFornitore="garmont"
            titoloPagina="Tracciato Garmont"
          />
        )}
        {tab === "reusch" && (
          <TracciatoFornitore utente={utente}
            nomeFornitore="reusch"
            titoloPagina="Tracciato Reusch"
          />
        )}
        {tab === "poc" && (
          <TracciatoFornitore utente={utente}
            nomeFornitore="poc"
            titoloPagina="Tracciato Poc"
          />
        )}
        {tab === "Rh" && (
          <TracciatoFornitore utente={utente} nomeFornitore="rh" titoloPagina="Tracciato RH+" />
        )}
        {tab === "Leki" && (
          <TracciatoFornitore utente={utente}
            nomeFornitore="leki"
            titoloPagina="Tracciato Leki"
          />
        )}
        {tab === "Oberalp" && (
          <TracciatoFornitore utente={utente}
            nomeFornitore="oberalp"
            titoloPagina="Tracciato Oberalp Group"
          />
        )}
      </div>
    </div>
  );
}

export default AreaCSVupload;
